import { render, staticRenderFns } from "./imgDetailDialog.vue?vue&type=template&id=080ee01a"
import script from "./imgDetailDialog.vue?vue&type=script&lang=js"
export * from "./imgDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./imgDetailDialog.vue?vue&type=style&index=0&id=080ee01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports